import { apiFetch } from './api';
import { useAuthStore } from '../store/useAuthStore';

// --- Types (mirror backend modules/email/gmailConnections.service) ----------

export interface GmailConnection {
  id: string;
  userId: string;
  provider: string;
  gmailEmail: string;
  gmailLabel: string | null;
  status: 'connected' | 'expired';
  isActive: boolean;
  needsReauth: boolean;
  lastError: string | null;
  connectedAt: string;
  lastSyncAt: string | null;
  /** True when the grant lets Firmio AI leave drafts (gmail.compose). */
  canDraft: boolean;
}

export interface GmailConnectionsResponse {
  connections: GmailConnection[];
  googleConfigured: boolean;
}

interface Envelope<T> {
  success: true;
  data: T;
}

function authHeaders(): Record<string, string> {
  const token = useAuthStore.getState().accessToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// GET /api/users/:userId/gmail
export async function listGmailConnections(userId: string): Promise<GmailConnectionsResponse> {
  const res = await apiFetch<Envelope<GmailConnectionsResponse>>(`/api/users/${userId}/gmail`, {
    headers: authHeaders(),
  });
  return res.data;
}

// POST /api/users/:userId/gmail/connect -> { authUrl }
export async function startGmailConnect(
  userId: string,
  label?: string,
): Promise<{ authUrl: string }> {
  const res = await apiFetch<Envelope<{ authUrl: string }>>(`/api/users/${userId}/gmail/connect`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(label ? { label } : {}),
  });
  return res.data;
}

// DELETE /api/users/:userId/gmail/:connectionId
export async function disconnectGmail(
  userId: string,
  connectionId: string,
): Promise<{ disconnected: boolean }> {
  const res = await apiFetch<Envelope<{ disconnected: boolean }>>(
    `/api/users/${userId}/gmail/${connectionId}`,
    { method: 'DELETE', headers: authHeaders() },
  );
  return res.data;
}
